import classNames from 'classnames';
import { Button } from 'components/atoms/Button';
import type { FC } from 'react';

const TabsToggle: FC<{
  tabs: {
    label: string;
    value: string;
    badge?: {
      text: string;
    };
  }[];
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
}> = ({ tabs, selectedTab, setSelectedTab }) => (
  <div className="bg-primary-50 flex items-center p-2 rounded-lg w-full">
    {tabs.map(({ label, value, badge }) => {
      const isSelected = selectedTab === value;

      return (
        <Button
          asDefault
          key={value}
          structure="primary"
          className={classNames(
            'text-sm flex-1 !py-1.5 !border-none !ring-0 cursor-pointer !outline-none font-semibold rounded-10 transition-colors',
            {
              '!bg-white !text-primary shadow-sm': isSelected,
              '!text-primary-400 !bg-transparent': !isSelected,
            },
          )}
          onClick={() => setSelectedTab(value)}
        >
          {label}
          {badge?.text && (
            <span className="bg-taxes-100 text-taxes-700 px-2 py-1 ml-2 rounded-full text-xs font-medium">
              {badge.text}
            </span>
          )}
        </Button>
      );
    })}
  </div>
);

export default TabsToggle;
